/* Lumore — minimal progressive-enhancement JS.
   No frameworks, no polling, no libraries: <details>/<summary> already
   powers the FAQ accordion natively, so this file only handles the two
   things that truly need JS. Loaded with `defer` — never blocks render. */
(function () {
  'use strict';

  // Search toggle: dispatches an event other sections/apps can hook into
  // instead of assuming a specific drawer markup exists.
  document.querySelectorAll('[data-lumore-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('lumore:search-toggle'));
    });
  });

  // Cart count badge: keep header in sync after an /cart/add submission
  // without a full page reload, using Shopify's own Ajax Cart API.
  document.querySelectorAll('.l-add-form').forEach(function (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-lumore-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {
          form.submit(); // graceful fallback to a normal POST
        });
    });
  });

  // Age / responsible-use gate.
  var ageGate = document.querySelector('[data-lumore-age-gate]');
  if (ageGate) {
    var confirmBtn = ageGate.querySelector('[data-lumore-age-confirm]');
    var denyBtn = ageGate.querySelector('[data-lumore-age-deny]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        try { localStorage.setItem('lumore_age_verified', 'true'); } catch (e) {}
        document.documentElement.classList.add('age-verified');
      });
    }
    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        var redirect = denyBtn.getAttribute('data-redirect');
        window.location.href = redirect && redirect !== '' ? redirect : 'https://www.google.com';
      });
    }
  }

  // CoA lookup form: only intercepted if the merchant hasn't configured a
  // real portal URL yet, so we never fabricate a "verified" result.
  document.querySelectorAll('[data-lumore-coa-form]').forEach(function (form) {
    var action = form.getAttribute('action');
    if (action && action !== '#') return; // let it submit to the real portal
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var resultEl = form.parentElement.querySelector('[data-lumore-coa-result]');
      if (resultEl) {
        resultEl.hidden = false;
        resultEl.textContent = 'Configure a CoA portal URL in the section settings to enable live lookups.';
      }
    });
  });
})();
/* ==========================================================================
   Lumore Theme | Extensión v1.3.2 — Elaborado por La Fotoforma
   JS de soporte para: Producto (galería/variantes), Carrito (cantidades),
   Cuentas (confirmar borrado de direcciones). Progresivo, sin frameworks.
   100% aditivo — no se modifica ninguna función existente.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Product gallery: click a thumb to swap the main image ---------- */
  document.querySelectorAll('[data-lumore-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-lumore-gallery-main]');
    gallery.querySelectorAll('[data-lumore-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        var full = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (full) {
          main.src = full;
          main.alt = alt;
        }
        gallery.querySelectorAll('[data-lumore-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity steppers (product page + cart) ---------- */
  document.querySelectorAll('[data-lumore-qty]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    function clamp(val) {
      var min = parseInt(input.min || '1', 10);
      var max = input.max ? parseInt(input.max, 10) : null;
      if (isNaN(val) || val < min) val = min;
      if (max && val > max) val = max;
      return val;
    }
    if (minus) {
      minus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value || '1', 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value || '1', 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* ---------- Cart page: quantity change updates the line via Ajax Cart API ---------- */
  document.querySelectorAll('[data-lumore-cart-qty]').forEach(function (input) {
    var timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      var line = input.getAttribute('data-line');
      var qty = parseInt(input.value || '0', 10);
      timer = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { input.closest('form') && input.closest('form').submit(); });
      }, 300);
    });
  });

  /* ---------- Confirm before removing a saved address ---------- */
  document.querySelectorAll('[data-lumore-confirm]').forEach(function (el) {
    el.addEventListener('click', function (evt) {
      var msg = el.getAttribute('data-lumore-confirm');
      if (!window.confirm(msg)) evt.preventDefault();
    });
  });

  /* ---------- Address form: toggle "same as shipping" edit panels open/closed ---------- */
  document.querySelectorAll('[data-lumore-toggle-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-lumore-toggle-target'));
      if (target) target.hidden = !target.hidden;
    });
  });
})();

/* ==========================================================================
   Lumore Theme | v1.3.2 — Sign-up tag persistence
   Shopify can re-render the standard register page when a sign-up fails
   validation (e.g. email already used). That round trip would drop the
   affiliate tag posted from the Affiliate register page, so the tag is kept
   for the length of the browser tab and put back on the retried form.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'lumore_signup_tag';
  document.querySelectorAll('[data-lumore-signup-form]').forEach(function (form) {
    var tagInput = function () { return form.querySelector('input[name="customer[tags]"]'); };

    form.addEventListener('submit', function () {
      var input = tagInput();
      try {
        if (input && input.value) sessionStorage.setItem(KEY, input.value);
        else sessionStorage.removeItem(KEY);
      } catch (e) {}
    });

    var failed = form.querySelector('[data-lumore-signup-failed]');
    try {
      if (failed) {
        var saved = sessionStorage.getItem(KEY);
        if (saved && !tagInput()) {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'customer[tags]';
          hidden.value = saved;
          form.appendChild(hidden);
        }
      } else {
        sessionStorage.removeItem(KEY);
      }
    } catch (e) {}
  });
})();
